module.exports = __webpack_public_path__ + "img/remove.e683363d.svg";